import { ImageLoaderType } from '@/types/model';

export const ImageLoader = ({ src }: ImageLoaderType) => {
  if (!src) return '';
  if (src.startsWith('http://') || src.startsWith('https://')) return src;

  const base = process.env.NEXT_PUBLIC_UPLOAD_ASSETS || '';
  const normalizedSrc = src.startsWith('/') ? src : `/${src}`;
  return `${base}${normalizedSrc}`;
};

export const SvgLoader = ({ src }: ImageLoaderType) => {
  return `${process.env.NEXT_PUBLIC_UPLOAD_ASSETS}${src}`;
};
